import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import { colors } from "../themes";
import { colorFromTheme } from "../utils/color";

const StyledCallout = styled.div<{ backgroundColor: colors | undefined }>`
  border-radius: 0.5rem;
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  border: solid 1px #ddd;
  padding: 0.3rem;
  box-sizing: border-box;
  background-color: ${(p) =>
    p.backgroundColor ? colorFromTheme(p.backgroundColor) : "none"};
`;
const StyledIndicator = styled.div<{ color: colors }>`
  border-radius: 0.5rem;
  width: 0.3rem;
  background-color: ${(p) => colorFromTheme(p.color)};
`;
const StyledIcon = styled.div`
  align-self: center;

  svg {
    display: block;
  }
`;
const StyledBody = styled.div`
  line-height: 1.5em;
  padding: 0.5rem 0.5rem;
  flex: 1;
`;

/**
 * The better looking `<Banner />`.
 *
 * Experiementing with this in a few places in Lowman and TCMPC, might consider
 * refactoring banners to look this way. */
const Callout = (
  props: PropsWithChildren<{
    icon?: React.ReactNode;
    indicatorColor?: colors;
    backgroundColor?: colors;
    className?: string;
  }>,
) => {
  return (
    <StyledCallout
      className={props.className}
      backgroundColor={props.backgroundColor}
    >
      <StyledIndicator color={props.indicatorColor ?? "surface6"} />
      {props.icon && <StyledIcon>{props.icon}</StyledIcon>}
      <StyledBody>{props.children}</StyledBody>
    </StyledCallout>
  );
};

export default Callout;
